import React from "react";
import LoginComp from "../components/login/LoginComp";

const Login = () => {
  return (
    <div>
      <LoginComp />
    </div>
  );
};

export default Login;
